import { MonthlyStepsChart } from './MonthlyStepsChart.ts';

document.addEventListener('DOMContentLoaded', () => {
    // --- 1. ターゲット要素の取得 (新仕様: Role属性ベース) ---
    // data-chart-role="container" かつ data-chart-type="monthly-steps-chart" の要素を検索
    const chartWrappers = document.querySelectorAll('[data-chart-role="container"][data-chart-type="monthly-steps-chart"]');

    chartWrappers.forEach(wrapper => {
        const initializeChart = async () => {
            // --- 2. 内部要素の取得 (新仕様: Role属性ベース) ---
            // クラス名には依存せず、Role属性で要素を特定する
            const chartArea = wrapper.querySelector('[data-chart-role="chart-area"]');
            // PHPヘルパーが出力するコントロール用コンテナ (c-chart-controls)
            const controlsContainer = wrapper.querySelector('[data-chart-role="controls"]');

            if (!chartArea) {
                console.error('[monthly-steps-chart] Error: Chart area (role="chart-area") not found.');
                return;
            }

            if (chartArea._chartInstance) {
                return; // 二重初期化防止
            }

            // ▼▼▼ ここからが修正箇所 ▼▼▼
            // --- 3. 設定オブジェクトの構築 ---
            const config = {};
            const duration = chartArea.dataset.duration;

            if (duration && !isNaN(parseInt(duration, 10))) {
                config.animationInterval = parseInt(duration, 10);
                console.log(`[monthly-steps-chart] Custom duration set: ${config.animationInterval}ms`);
            }
            
            // --- 4. グラフインスタンスの生成 (設定オブジェクトを渡す) ---
            console.log('[monthly-steps-chart] Creating instance...');
            const chart = new MonthlyStepsChart(chartArea, config); // 第2引数にconfigを渡す
            // ▲▲▲ ここまでが修正箇所 ▲▲▲

            chartArea._chartInstance = chart;
            chartArea.dataset.chartInstance = 'true';

            try {
                // --- 5. 非同期初期化 ---
                await chart.init();

                // --- 6. UI構築 (コントロールコンテナがある場合のみ) ---
                if (controlsContainer) {
                    // 6a. ユーザー操作の管理フラグ
                    let userHasInteracted = false;
                    const handleUserInteraction = () => {
                        if (!userHasInteracted) {
                            userHasInteracted = true;
                            chart.config.autoplay = false;
                        }
                    };

                    // 6b. UI要素の動的生成
                    // ※CSSでレイアウト制御を行うため、ここではHTML構造の生成に徹する
                    controlsContainer.innerHTML = `
                        <button class="play-pause-button" aria-label="再生/一時停止"></button>
                        <input type="range" class="time-slider" min="0" max="0" value="0" step="1">
                        <span class="current-step-display"></span>
                    `;

                    // 6c. 生成した要素への参照取得
                    const playPauseButton = controlsContainer.querySelector('.play-pause-button');
                    const slider = controlsContainer.querySelector('.time-slider');
                    const stepDisplay = controlsContainer.querySelector('.current-step-display');

                    // 6d. イベントリスナーを設定
                    if (playPauseButton) {
                        playPauseButton.addEventListener('click', () => {
                            handleUserInteraction();
                            chart.togglePlayPause();
                        });
                    }
                    if (slider) {
                        slider.addEventListener('input', (event) => {
                            handleUserInteraction();
                            const frame = parseInt(event.target.value, 10);
                            chart.seek(frame);
                        });
                    }

                    // 6e. グラフからのUI更新コールバック
                    chart.onUpdateUI(state => {
                        // 再生中クラスはラッパーに付与 (共通CSSがこれを利用してアイコンを切り替える)
                        wrapper.classList.toggle('is-playing', state.isPlaying);

                        if (slider) {
                            // アニメーション終了時の挙動調整
                            const currentFrame = (state.currentFrame < 0 && !state.isPlaying) ? 0 : state.currentFrame;
                            const totalFrames = state.totalFrames > 0 ? state.totalFrames - 1 : 0;

                            if (slider.max != totalFrames) {
                                slider.max = totalFrames;
                            }
                            slider.value = currentFrame;
                        }
                        if (stepDisplay) {
                            stepDisplay.textContent = state.currentDataPoint ? state.currentDataPoint.label : '';
                        }
                    });

                    // 6f. 自動再生トリガー
                    if (chart.config.autoplay) {
                        setTimeout(() => {
                            if (!userHasInteracted && playPauseButton) {
                                playPauseButton.click();
                            }
                        }, chart.config.autoplayDelay);
                    }
                } else {
                    console.warn('[monthly-steps-chart] Warning: Controls container (role="controls") not found.');
                }

            } catch (error) {
                console.error('[monthly-steps-chart] Initialization failed:', error);
            }
        };

        initializeChart();
    });
});